import CommercialStagingForm from "./CommercialStagingForm"

const ObjectRemovalForm = () => {
    return (
        <CommercialStagingForm unitPrice={8} form_name="Object Removal" />
    )
}

export default ObjectRemovalForm;